import { useEffect, useRef, useState } from "react";

export default function CustomCursor() {

    const cursorRef = useRef(null);
    const dotRef = useRef(null);

    const [hovered, setHovered] = useState(false);
    const [text, setText] = useState("");


    useEffect(() => {

        const moveCursor = (e) => {

            const x = e.clientX;
            const y = e.clientY;


            if (cursorRef.current) {
                cursorRef.current.style.transform =
                    `translate3d(${x}px, ${y}px, 0) translate(-50%, -50%)`;
            }


            if (dotRef.current) {
                dotRef.current.style.transform =
                    `translate3d(${x}px, ${y}px, 0) translate(-50%, -50%)`;
            }


            const target = e.target.closest("a, button");


            if (target) {

                setHovered(true);


                if (target.href?.includes("/hotels")) {
                    setText("VIEW");
                }
                else if (target.tagName === "BUTTON") {
                    setText("CLICK");
                }
                else {
                    setText("OPEN");
                }

            }
            else {

                setHovered(false);
                setText("");

            }

        };


        window.addEventListener(
            "mousemove",
            moveCursor
        );


        return () => {
            window.removeEventListener(
                "mousemove",
                moveCursor
            );
        };


    }, []);



    return (
        <>


            {/* Outer Cursor */}
            <div
                ref={cursorRef}
                className={`
        pointer-events-none
        fixed
        left-0
        top-0
        z-[9999]
        rounded-full
        flex
        items-center
        justify-center
        font-bold
        text-[8px]
       transition-[width,height,background-color,transform]
duration-200
ease-out

        ${hovered
                        ?
                        "w-12 h-12 bg-[#D9BB74] text-[#1B1B1B] scale-105"
                        :
                        "w-7 h-7 border-2 border-[#D9BB74]"
                    }
    `}
            >
                {hovered && text}

            </div>



            {/* Inner Dot */}
            {!hovered && (
                <div
                    ref={dotRef}
                    className="
                        pointer-events-none
                        fixed
                        left-0
                        top-0
                        z-[9999]
                        w-3
                        h-3
                        rounded-full
                        bg-[#0F766E]
                    "
                />
            )}


        </>
    );
}